define('cartware/components/PubSubHub',[
	"lodash",
	"lucid"
], function(
	_,
	lucidJS
) {

	var _instance = null;

	var getInstance = function() {
		if (_instance === null) {
			_instance = new PubSubHub();
		}

		return _instance;
	};

	function PubSubHub() {
		if (!(this instanceof PubSubHub)) {
			return getInstance();
		}

		lucidJS.EventEmitter.call(this);

		this._register = {};
	}

	PubSubHub.getInstance = getInstance;

	PubSubHub.prototype = _.create(new lucidJS.EventEmitter, {
		"constructor": PubSubHub
	});

	return PubSubHub.getInstance();
});
